import type {VisibilityChangeEvent} from 'common/components/base/stacking-context';

// Marks the element that renders a drop menu. Code that needs to recognise drop menus (stacking,
// drag guards, styles, tests) matches this attribute rather than the `mp-drop-menu` tag name.
export const DROP_MENU_ATTR = `data-drop-menu`;
export const DROP_MENU_SELECTOR = `[${DROP_MENU_ATTR}]`;

export enum Directions {
  Down = `down`,
  DownCenter = `downCenter`,
  DownRight = `downRight`,
  Right = `right`,
  RightCenter = `rightCenter`,
  RightBottom = `rightBottom`,
  Up = `up`,
  UpRight = `upRight`,
  UpCenter = `upCenter`,
  Left = `left`,
}

export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum PositionParentType {
  ParentElement = `parentElement`,
}

// use "const enum" for backward compatibility with raw menu state strings
// "const enum" forces Typescript to simply inline the enum value when compiled
export const enum MenuState {
  Open = `open`,
  Closed = `closed`,
}

export interface DropMenuAttrs {
  'allowed-flip-directions'?: Directions[];
  'disable-auto-focus'?: boolean;
  'experimental-positioning'?: boolean;
  'position-strategy'?: PositioningStrategy;
  'force-stacking'?: boolean;
  'prevent-close-selectors'?: string[];
  'prevent-close'?: boolean;
  'prevent-stacking'?: boolean;
  'show-arrow'?: boolean;
  'disable-auto-update'?: boolean;
  direction?: Directions;
  offset?: number;
  open?: boolean;
  onChange?: (ev: VisibilityChangeEvent) => void;
}
